import LoginImage from './assets/caislogo_blue.png';
import dummyVideos from './data/dummyVideos';
import MatchboxIcon from './assets/favicon.ico';
import MatchboxLogo from './assets/matchbox-logo-white-small.png';
import bannerImage from './assets/CAISSpacesBanner_TimeDate.jpg';

const SiteData = {
  loginTitle:
    "Welcome to CAIS 2021 Trustee/School Head Online Conference!",
  loginImagesrc: LoginImage,
  loginImagealt: 'Cais Logo',
  attendeeTitle:
    'CAIS 2021 Trustee/School Head Online Conference',
  matchboxLogo: MatchboxIcon,
  matchboxIcon: MatchboxLogo,
  endOfEventPageTitle: 'CAIS 2021 Trustee/School Head Online Conference',
  matchboxLogoAlt: 'matchbox logo',
  matchboxLogoTitle: 'hello',
  attendantTitle: 'CAIS 2021 Trustee/School Head Online Conference',
  titleIndex: 'CAIS 2021 Trustee/School Head Online Conference',
  auditorium: true,
  checkRegisterList: false,
  generalChatId: 1,
  auditoriumChatIds: [44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64],
  schemaName: 'cais',
  Isbanner: true,
  isMultipleAuditorium: true,
  bannerData: {
    backgroundURL: bannerImage,
  //   videoURL:
  //     'https://expohallimages.s3-us-west-2.amazonaws.com/STE+Pre-Show.mp4',
  },
};
export default SiteData;
